import ManualLink from '../../ManualLink';
import './moderation-banner.scss';

export interface ModerationMeta {
  status: 'hidden_pending_rewrite' | 'removed';
  templateKey: string;
  headline: string;
  body: string;
  moderatorUsername: string;
  resolvedAt: string;
}

interface Props {
  meta: ModerationMeta;
  onEdit?: () => void;
}

export default function ModerationBanner({ meta, onEdit }: Props) {
  const isRewrite = meta.status === 'hidden_pending_rewrite';
  const reviewedAt = new Date(meta.resolvedAt);
  const reviewedAtLabel = Number.isNaN(reviewedAt.getTime())
    ? meta.resolvedAt
    : reviewedAt.toLocaleString();

  return (
    <div
      className={`ModerationBanner ${isRewrite ? 'is-rewrite' : 'is-remove'}`}
      data-testid="moderation-banner"
      role="region"
      aria-label={isRewrite ? 'Post pending rewrite' : 'Post removed'}
    >
      <div className="ModerationBanner__Header">
        <strong className="ModerationBanner__Title">
          {isRewrite
            ? 'Please rewrite this post'
            : 'This post has been removed'}
        </strong>
        <span className="ModerationBanner__Meta">
          reviewed by @{meta.moderatorUsername} · {reviewedAtLabel}
        </span>
      </div>
      <div className="ModerationBanner__Headline">{meta.headline}</div>
      <div className="ModerationBanner__Body">{meta.body}</div>
      <ManualLink
        section="moderation"
        sub="being-reported"
        label="How moderation works"
        className="ModerationBanner__Manual"
      />
      {isRewrite ? (
        <div className="ModerationBanner__Footer">
          <span className="ModerationBanner__Note">
            Your post is hidden from other users until you save an edit. Saving
            auto-republishes it.
          </span>
          {onEdit && (
            <button
              type="button"
              className="ModerationBanner__Edit"
              onClick={onEdit}
            >
              Edit post →
            </button>
          )}
        </div>
      ) : (
        <div className="ModerationBanner__Footer">
          <span className="ModerationBanner__Note">
            This decision was made by a moderator. If you believe it was made in
            error, contact support or wait for an admin review.
          </span>
        </div>
      )}
    </div>
  );
}
